import { useEffect, useRef, useState } from 'react';
import { View } from 'react-native';
import { ImageDocumentStoreItem } from '@v2/components/imageHandling/types/types';
import { navigationRef, parseRouteParamAsNumber } from '@helpers';

interface UseManageAttachButtonParams {
  images: ImageDocumentStoreItem[];
  selectedIndex?: number;
}

export const useManageAttachButton = ({ images, selectedIndex }: UseManageAttachButtonParams) => {
  const route = navigationRef?.current?.getCurrentRoute();
  const selectedImageKey = route?.params?.selectedImageKey;
  const documentId = parseRouteParamAsNumber(route?.params?.documentId);

  const attachButtonRef = useRef<View | null>(null);
  const [attachButtonMeasurements, setAttachButtonMeasurements] = useState<{ x: number; y: number }>({ x: 0, y: 0 });

  const selectedImage = images?.find((i) => i.contentHash === selectedImageKey || (documentId != null && i.documentId === Number(documentId)))
    ?? (selectedIndex != null ? images?.[selectedIndex] : undefined);
  const amountOfLinks = selectedImage?.links?.length;

  useEffect(() => {
    // We need it because we can have animation and position should be stored after animation has finished
    const timer = setTimeout(() => {
      attachButtonRef.current?.measureInWindow((x, y) => {
        setAttachButtonMeasurements({ x, y });
      });
    }, 400);

    return () => clearTimeout(timer);
  }, [attachButtonRef]);

  return {
    attachButtonRef,
    amountOfLinks,
    selectedImage,
    attachButtonMeasurements,
  };
};
